export default "__VITE_ASSET__79df0f34__"